const BETRADAR_SETUP_FEATURE_KEY = "betradarSetup";
const HOF_SPORT_SORTING_FEATURE_KEY = "hofSport";
export {
  BETRADAR_SETUP_FEATURE_KEY,
  HOF_SPORT_SORTING_FEATURE_KEY
};
